import React from "react";
import styled from "styled-components";

import { Input, InputEvent } from "@ui/Atoms";
import { rem } from "@ui/helpers";
import { FlowPanel } from "@ui/Molecules";

interface Props {
  onChange: (value: string) => void;
  value: string;
  translations?: {
    headingText?: string;
    optionalText?: string;
  };
  headingText?: string;
  className?: string;
}

const Comment = (props: Props): React.ReactElement => {
  const { headingText, optionalText } = props.translations ?? {};

  return (
    <Content className={props.className}>
      {!!headingText && (
        <StyledTitle type="h5" size="small">
          {headingText}
        </StyledTitle>
      )}
      <StyledInput
        forwardedAs="textarea"
        onChange={(e: InputEvent) => props.onChange(e.currentTarget.value)}
        value={props.value}
        optionalLabel={optionalText}
      />
    </Content>
  );
};

export { Comment };

const Content = styled.div`
  width: 100%;
  max-width: ${rem(600)};
  margin: 0 auto;
  text-align: left;
`;

const StyledTitle = styled(FlowPanel.Title)`
  margin-bottom: ${props => props.theme.margins.base_x3};

  ${props => props.theme.breakpoints.tablet} {
    margin-bottom: ${props => props.theme.margins.base_x4};
  }
`;

const StyledInput = styled(Input)`
  margin: 0 auto;
  min-height: ${rem(128)};

  ${props => props.theme.breakpoints.tablet} {
    min-height: ${rem(160)};
  }
`;
